angular.module('cfn').directive('cfnFixedCol', [
  '$rootScope',
  '$log',
  function($rootScope, $log) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        attrs.$observe('cfnWidth', function(val) {
          element.css('width', val + 'px');
          element.css('max-width', val + 'px');
          element.css('min-width', val + 'px');
        });
      }
    };
  }
]);
